import { type BeginCheckoutEvent, beginCheckoutEventSchema } from './eCommerceTrackingEventSchema';
import { getCatalogSourceTrackingData } from './catalogSourceStorage';
import logger from '../logger';

export type BeginCheckoutEventProps = Omit<BeginCheckoutEvent, 'event_name' | 'event'>;

export const buildBeginCheckoutEvent = (props: BeginCheckoutEventProps): BeginCheckoutEvent => {
  const beginCheckoutEvent: BeginCheckoutEvent = {
    event: 'ga4_event_ecommerce',
    event_name: 'begin_checkout',
    ...props,
    ecommerce: { ...props.ecommerce, ...getCatalogSourceTrackingData() }
  };

  const result = beginCheckoutEventSchema.safeParse(beginCheckoutEvent);

  if (!result.success) {
    logger.error(result.error, 'Invalid begin checkout event');
  }

  return beginCheckoutEvent;
};
